import { createSlice } from '@reduxjs/toolkit';
import {FormAttributeInit} from "./model";

const initialState = {
    attributesForm: FormAttributeInit,
};

const attributeSlice = createSlice({
    name: 'attribute',
    initialState,
    reducers: {
        setAttributesForm: (state, action) => {
            state.attributesForm = action.payload;
        },
        onChangeAttributesForm: (state, action) => {
            const { name, value } = action.payload;
            state.attributesForm[name] = value;
        },
        initAttributeForm: (state, action) => {
            state.attributesForm = FormAttributeInit
        }
    },
});

export const { actions } = attributeSlice;
export const {
    setAttributesForm,
    onChangeAttributesForm,
    initAttributeForm
} = actions;

// reducers

// selectors
export const selAttributesForm = (state) => state.attribute.attributesForm;


const attributeReducer = {
    attribute: attributeSlice.reducer,
};
export default attributeReducer;
